import React from 'react';

import { Box, Text, VStack, StackDivider } from '@chakra-ui/react';

import { CloseIcon } from '../../../Icons/Icons';

type SearchHistoryListProps = {
  history: string[];
  className?: string;
  handleSearch: (data: string) => void;
  handleRemove: (data: string) => void;
};

const SearchHistoryList = ({
  className,
  handleSearch,
  handleRemove,
  history,
}: SearchHistoryListProps) => {
  if (history?.length === 0) {
    return null;
  }

  return (
    <Box className={className} w="100%">
      <Text color="neutral.55" fontSize="xs" fontWeight="bold" mb={3}>
        RECENT SEARCHES
      </Text>
      <VStack
        align="stretch"
        divider={
          <StackDivider
            borderColor="neutral.5"
            display={{ base: 'none', md: 'block' }}
          />
        }
        spacing={0}
      >
        {history?.map((item, index) => (
          <Box
            as="li"
            color="black"
            cursor="pointer"
            display="flex"
            fontSize="xs"
            fontWeight="normal"
            justifyContent="space-between"
            key={item}
            py={3}
            w="100%"
            onClick={() => handleSearch(item)}
          >
            <Text noOfLines={1}>{item}</Text>
            <Box
              onClick={(event) => {
                event.stopPropagation();
                handleRemove(item);
              }}
            >
              <CloseIcon boxSize={4} />
            </Box>
          </Box>
        ))}
      </VStack>
    </Box>
  );
};

export { SearchHistoryList };
